import { render } from "./FechaDeRegistro.vue?vue&type=template&id=6cad6274"
import script from "./FechaDeRegistro.vue?vue&type=script&lang=js"
export * from "./FechaDeRegistro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__